<script setup>
import { defineProps, toRefs, ref, defineEmits } from "vue"
import PreviewImg from "@/components/common/PreviewImg";
const props = defineProps({
    image: {
        type: Object,
        required: true
    },
    showDelete: {
        type: Boolean,
        default: false
    }
})
const emits = defineEmits("delete")
const { image,showDelete } = toRefs(props)
const activeImageSrc = ref('')
const showPreviewImg = ref(false)

const handleImgPreview = (item) => {
    // 图片预览
    activeImageSrc.value = item;
    if (activeImageSrc.value == "") {
        return;
    }
    showPreviewImg.value = true;
}

const handleDownload = (data, name) => {
    // 文件下载
    let url = data
    const x = new window.XMLHttpRequest();
    x.open('GET', url, true);
    x.responseType = 'blob';
    x.onload = () => {
        const url = window.URL.createObjectURL(x.response);
        const a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
    };
    x.send();
}

const handleDelete = (url) => {
    emits("delete", url);
}
</script>
<template>
    <div style="width: 100%;height: 100%; position: absolute;top:0" class="file-action">
        <div style="width: 100%; height: 100%; background-color: #7f7f7f;opacity: 0.8; position: absolute; display: none;"
            class="showAction">
        </div>
        <div style="position: absolute; bottom: 0;display: none; width: 100%; text-align: center;" class="showAction">
            <i v-if="image.type != 'file'" @click="handleImgPreview(image.url ||image.src)" class="ri-eye-fill mx-2 cursor-pointer"
                style="font-size: 25px;color: white;"></i>
            <i @click="handleDownload(image.url ||image.src, image.filename)" class="ri-download-2-fill mx-2 cursor-pointer"
                style="font-size: 25px;color: white;"></i>
            <i v-if="showDelete" @click="handleDelete(image.url ||image.src)" class="ri-delete-bin-5-fill mx-2 cursor-pointer"
                style="font-size: 25px;color: white;"></i>
        </div>
        <PreviewImg v-model:showPreviewImg="showPreviewImg" :src="activeImageSrc" v-if="showPreviewImg"></PreviewImg>
    </div>
</template>
<style>
.file-action {
    &:hover {
        .showAction {
            display: block !important;
        }
    }
}
</style>